import Page from '@pelckmans/elementis/components/page';
import { useContext } from 'react';
import { Node } from '../../../../../api/table-of-content';
import { findDeepNodeById } from '../../../../../utils/tocNode';
import { MaterialDataContext } from '../../../_contexts/MaterialDataProvider';
import ModuleContext from '../../../_contexts/ModuleContext';
import TableOfContentsContext from '../../_contexts/TableOfContentsContext';
import AppButtonList from './AppButtonList';
import NodeHierarchyBreadcrumbs from './NodeHierarchyBreadcrumbs';
import useDigibook from '../../../hooks/useDigibook';

interface TocPageHeaderProps {
  density: 'normal' | 'compact';
}

function TocPageHeader({ density }: TocPageHeaderProps) {
  const { module } = useContext(ModuleContext);
  const { selectedNode, nodes } = useContext(TableOfContentsContext);
  const { selectedNodeIds } = useContext(MaterialDataContext);
  const { digibook } = useDigibook();

  if (!module || !selectedNode) return null;

  const nodeHierarchy = selectedNodeIds.map(id => findDeepNodeById(nodes, id)) as Node[];
  const hideBreadcrumbs =
    nodeHierarchy.length === 0 ||
    (nodeHierarchy.length === 1 && (Boolean(!nodeHierarchy[0]?.displayPrefix) || Boolean(!nodeHierarchy[0]?.prefix)));

  return (
    <Page.Header
      density={density}
      headerText={selectedNode.title}
      cover={{
        backgroundImageUrl: module.styling?.visual,
      }}
      extra={<AppButtonList density={density} />}
      {...(!hideBreadcrumbs && {
        breadcrumbs: (
          <NodeHierarchyBreadcrumbs nodeHierarchy={nodeHierarchy} size={density === 'compact' ? 'sm' : 'md'} />
        ),
      })}
      hasDigibookManual={Boolean(digibook?.manual)}
      isSticky
    />
  );
}

export default TocPageHeader;
